
// This string must match one of the directories in public/video and src/assets/img

//export const wlPath = 'example';
export const wlPath = 'cbda';
